import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { FileUploadModel } from '../Models/fileupload.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { ActivatedRoute } from '@angular/router';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { AuthService } from 'app/auth/auth.service';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { WebSocketService } from 'app/EMR/webSocket.Service';


export interface DialogData {
  animal: string;
  name: string;
}


@Component({
  selector: 'app-patientdocs',
  templateUrl: './patientdocs.component.html',
  styleUrls: ['./patientdocs.component.scss']
})
export class PatientdocsComponent implements OnInit {

  displayedColumns: string[] = ['filename', 'action'];
  //dataSource = ELEMENT_DATA;
  url = "./assets/img/noimage.png";
  documents: any[] = [];
  showspinner = false;
  selectedFile: File = null;
  filenotselected = true;

  fileupload: FileUploadModel;
  documentname: string = "";
  filename: string = "No Files";
  setupload = true;
  setadddoc = true;
  baseurl: string;
  documentrul = [];
  loaderdialog;
  mainUrl: any;
  PatientId: any;
  folderName: string;
  branchId: any;
  isclosebtn: boolean;


  constructor(
    public dialogRef: MatDialogRef<PatientdocsComponent>,
    public http: HttpClient,
    public opdvisitService: OpdVisitService,
    public ipdservice: IPDService,
    public authService: AuthService,
    //  public datepipe: DatePipe,
    public dashboardService: DashboardService,
    public dialog: MatDialog, private route: ActivatedRoute,
    public imageWorkupService: imageworkupService, public translate: TranslateService,
    public langservice: LanguageService, private webSocketService: WebSocketService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    dialogRef.disableClose = true;
    this.isclosebtn = true;
    this.folderName = ' ';
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
  }

  ngOnInit() {

    // get patient docs
    // this.opdvisitService.get_patient_docs();
    //this.authService.webstorageConfigobj.storageType='server';
    if (this.route.snapshot.queryParamMap.get('PID')) {
      this.isclosebtn = false;
      this.folderName = this.route.snapshot.queryParamMap.get('PatientDocuments');
      this.branchId = this.route.snapshot.queryParamMap.get('BID');
      this.PatientId = this.route.snapshot.queryParamMap.get('PID');
      this.opdvisitService.patientdetails.pkRegId = this.PatientId;
      // this.dashboardService.getsummary_url().subscribe(data=>this.success_docurl(data),err=>this.failed_docurl(err))
      this.refreshdoc_list();

    }
    else {

      this.isclosebtn = true;
      this.PatientId = this.opdvisitService.patientdetails.pkRegId;
      this.folderName = 'PatientDocuments';
      this.refreshdoc_list();
      // this.documentURL();
    }


  }

  setdoc_button() {

  }

  // seturl(element){
  //  this.url = this.baseurl+"PatientDocuments/" + this.PatientId + "/" + element;
  // }

  onFileSelected(event) {

    console.log(event.target.files);
    this.selectedFile = <File>event.target.files[0];
    this.filename = this.selectedFile.name;

    this.filenotselected = false;

    if (event.target.files) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.url = event.target.result;
        this.setupload = false;

      }
    }
  }

  open_loader_Dialog(): void {

    this.loaderdialog = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    this.loaderdialog.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }

  onUpload() {
    if (this.documentname == undefined) {
      this.documentname = "";
    }
    var chekImg: any;
    // this.open_loader_Dialog();

    if (this.PatientId) {

      let fileToUpload = this.selectedFile;

      let fnsplit = this.selectedFile.name.split(".", 2);
      let actualdocumentname = this.documentname + "." + fnsplit[1];

      if (this.opdvisitService?.dataSource) {
        chekImg = this.opdvisitService?.dataSource?.find(o => o.documentName.toLowerCase() == actualdocumentname.toLowerCase());

      }
      if (!chekImg) {

        console.log(this.authService.webstorageConfigobj.storageType);
        const formData = new FormData();
        if (this.authService.webstorageConfigobj.storageType != null && this.authService.webstorageConfigobj.storageType != undefined) {
          if (this.authService.webstorageConfigobj.documentFileSize != null && this.authService.webstorageConfigobj.documentFileSize != undefined && Number(this.authService.webstorageConfigobj.documentFileSize) > 0) {
            if (Number(this.authService.webstorageConfigobj.documentFileSize) * 1024 >= fileToUpload.size) {
              formData.append('file', fileToUpload, actualdocumentname);
              formData.append('documentname', this.documentname);
              formData.append('patientid', this.PatientId.toString());
              formData.append('branchId', this.authService.Loggeduser.branchid.toString());
              formData.append('DocumentType', this.folderName);
              formData.append('FolderNameMain', this.folderName);
              formData.append('UserId', this.authService.Loggeduser.userid.toString());
              formData.append('ActionType', "UPLOAD");
              formData.append('StorageType', this.authService.webstorageConfigobj.storageType);
              formData.append('DocumentURL', this.opdvisitService.mainUrl);
              if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'server') {
                this.open_loader_Dialog();
                this.imageWorkupService.uploadDoc(formData)
                  .subscribe(
                    data => this.successfileupload(data), err => this.failedfileupload(err))
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
                this.open_loader_Dialog();
                this.imageWorkupService.uploadAzureDoc(formData)
                  .subscribe(
                    data => this.successfileupload(data), err => this.failedfileupload(err))
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {

                var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
                if (mainimagepath.length > 0) {
                  if (mainimagepath[0]?.propertyValue) {
                    const splitdata = this.url.split(',');
                    const message = {
                      "message": "UPLOADFILE",
                      "ACTIONTYPE": "UPLOAD",
                      "DOCUMENTTYPE": this.folderName.toUpperCase(),
                      "BranchId": this.authService.Loggeduser.branchid.toString(),
                      "PATIENTID": this.PatientId.toString(),
                      "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
                      "DOCUMENTNAME": String(actualdocumentname),
                      "CLIENTFILE": String(actualdocumentname),
                      "fileData": String(splitdata[1])
                    };

                    this.webSocketService.sendMessage(message);
                    this.webSocketService.getMessages().subscribe(
                      (message: any) => {

                        if (message) {
                          this.dashboardService.openSnackBar(message, "OK");
                          this.webSocketService.disconnect();
                          let payload = {
                            "PatientDocumentDetail": {
                              "ActionType": "UPLOAD",
                              "Pk_TranId": '0',
                              "Fk_BranchId": this.authService.Loggeduser.branchid.toString(),
                              "Fk_RegId": this.PatientId.toString(),
                              "Fk_CreatedById": this.authService.Loggeduser.userid,
                              "DocumentType": this.folderName.toUpperCase(),
                              "DocumentName": String(actualdocumentname),
                              "StorageType": this.authService.webstorageConfigobj.storageType.toUpperCase(),
                              "DocumentURL": mainimagepath[0]?.propertyValue + '/' + this.folderName.toUpperCase() + '/' + actualdocumentname
                            }
                          }
                          this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((x: any) => {
                            setTimeout(() => {
                              this.refreshdoc_list();
                            }, 500);

                          });

                        }

                      }, err => {

                        this.dashboardService.openSnackBar("Please set server configuration", "OK");
                      });
                  } else {
                    this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
                  }
                } else {
                  this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
                }

              } else {
                this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
              }
            } else {
              this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authService.webstorageConfigobj.documentFileSize + ' Kb', "OK");
            }
          } else {
            this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
        }
      }
      else {
        this.dashboardService.openSnackBar("This Document is Already Exist", "OK");
      }
    }
    else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }


  refreshdoc_list() {   
    // if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
    //   var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
    //   if (mainimagepath.length > 0) {
    //     const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEW", "DOCUMENTTYPE": this.folderName.toUpperCase(), "BranchId": this.authService.Loggeduser.branchid.toString(), "PATIENTID": this.PatientId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
    //     this.webSocketService.sendMessage(msg);
    //     this.webSocketService.getMessages().subscribe(
    //       (message: any) => {
    //         const filedat = message;
    //         if (filedat.length > 0) {
    //           this.opdvisitService.dataSource = message;
    //         }

    //       }, err => {
    //         this.dashboardService.openSnackBar("Please set server configuration", "OK");
    //       });
    //   } else {
    //     this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
    //   }
    // } else {
    this.imageWorkupService.getAzureImagedata(this.PatientId, this.authService.Loggeduser.branchid, this.folderName).subscribe(
      
      (data: any) => {
         this.opdvisitService.dataSource = [];
        if(data.length >0){
          this.opdvisitService.dataSource = data.filter(item=>item.storageType.toLowerCase() ==this.authService.webstorageConfigobj.storageType.toLowerCase());
        }
       
      }, err => {
        this.dialog.closeAll();
      });
    // }

  }

  successfileupload(data) {

    this.loaderdialog.close();
    this.setupload = true;
    this.url = "./assets/img/noimage.png";
    // this.showspinner = false;
    this.dashboardService.openSnackBar(this.selectedFile.name + " Uploaded Successfully", "OK");
    // this.opdvisitService.get_patient_docs();
    this.refreshdoc_list();
    this.filenotselected = true;
    this.documentname = "";
    this.selectedFile = null;

  }
  failedfileupload(err) {
    this.dashboardService.openSnackBar(this.selectedFile.name + "Upload Failed", "OK");
    this.filenotselected = true;
    this.dialog.closeAll();
  }

  close() {

    this.dialogRef.close();
  }
  windowopen(data) {
    window.open(data, "_blank");
  }

  deletedocument(element: any) {

    if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'server') {
      this.open_loader_Dialog();
      let payload = {
        "PatientDocumentDetail": {
          "ActionType": "DELETE",
          "Pk_TranId": element.pk_TranId,
          "Fk_BranchId": element.fk_BranchId,
          "Fk_RegId": element.fk_RegId,
          "Fk_CreatedById": this.authService.Loggeduser.userid,
          "DocumentType": element.documentType,
          "DocumentName": element.documentName,
          "DocumentURL": element.documentURL,
          "StorageType": element.storageType
        }
      }
      this.ipdservice.deleteServerPatientDocument(payload).subscribe(
        data => this.success_doc_delete(data), err => this.failed_doc_delete(err));
    } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'azure') {

      this.open_loader_Dialog();
      let payload = {
        "PatientDocumentDetail": {
          "ActionType": "DELETE",
          "Pk_TranId": element.pk_TranId,
          "Fk_BranchId": element.fk_BranchId,
          "Fk_RegId": element.fk_RegId,
          "Fk_CreatedById": this.authService.Loggeduser.userid,
          "DocumentType": element.documentType,
          "DocumentName": element.documentName,
          "DocumentURL": element.documentURL,
          "StorageType": element.storageType
        }
      }
      this.ipdservice.deleteAzurePatientDocument(payload).subscribe(
        data => this.success_doc_delete(data), err => this.failed_doc_delete(err));
    } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
   //   this.open_loader_Dialog();
      let payload = {
        "PatientDocumentDetail": {
          "ActionType": "DELETE",
          "Pk_TranId": element.pk_TranId,
          "Fk_BranchId": element.fk_BranchId,
          "Fk_RegId": element.fk_RegId,
          "Fk_CreatedById": this.authService.Loggeduser.userid,
          "DocumentType": element.documentType,
          "DocumentName": element.documentName,
          "DocumentURL": element.documentURL,
          "StorageType": element.storageType
        }
      }
      this.ipdservice.deleteServerPatientDocument(payload).subscribe((x: any) => {
       
        var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
        if (mainimagepath.length > 0) {        
          const msg = {
            "message": "UPLOADFILE",
            "ACTIONTYPE": "DELETE",
            "DOCUMENTTYPE": element.documentType.toUpperCase(),
            "BranchId": element.fk_BranchId.toString(),
            "PATIENTID": element.fk_RegId.toString(),
            "DocumentName": element.documentName.toString(),
            "MAINIMAGEPATH": mainimagepath[0]?.propertyValue
          }
          this.webSocketService.sendMessage(msg);
          this.webSocketService.getMessages().subscribe(
            (message: any) => {
              if (message) {
                this.webSocketService.disconnect();
                this.refreshdoc_list();
                this.dashboardService.openSnackBar("Delete Successfully", "OK");
                // this.loaderdialog.close();
              }
            }, err => {
              this.dashboardService.openSnackBar("Please set server configuration", "OK");
            });
        } else {
          this.dashboardService.openSnackBar("Please set mainimagepath", "OK");
        }
      });


    }

    // console.log ("delete doc " + element);
  }

  success_doc_delete(data) {
    this.loaderdialog.close();
    this.dashboardService.openSnackBar("Document deleted successfully", "OK");
    this.refreshdoc_list();
    // this.dialog.closeAll();
  }

  failed_doc_delete(err) {
    this.dashboardService.openSnackBar("Delete api failed", "OK");
    this.dialog.closeAll();
  }
  getupdateDocStatus(element: any) {
    if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
     
      var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
      if (mainimagepath.length > 0) {
        const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEWFILE", "DOCUMENTNAME": element.documentName, "DOCUMENTTYPE": element.documentType.toUpperCase(), "BranchId": element.fk_BranchId.toString(), "PATIENTID": element.fk_RegId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
        this.webSocketService.sendMessage(msg);
        this.webSocketService.getMessages().subscribe(
          (message: any) => {
            const filedat = message;
            if (Array.isArray(filedat)) {
              const splitdat = message[0].fbLong.split(/[:;,]+/);
              this.imageWorkupService.openBase64InBrowser(splitdat[3], splitdat[1], message[0].fName);
              
            }

          }, err => {
            this.dashboardService.openSnackBar("Please set server configuration", "OK");
          });
      } else {
        this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
      }
    } else {
      let payload = {

        "TId": element.pk_TranId,
        "BId": element.fk_BranchId,
        "RId": element.fk_RegId,
        "FType": element.documentType,
        "FName": element.documentName,
        "FSType": element.storageType
      }
      this.imageWorkupService.insertgetImagepath(payload).subscribe((x: any) => {

        if (
          x.fbLong
        ) {
          const splitdat = x.fbLong.split(/[:;,]+/);
          this.imageWorkupService.openBase64InBrowser(splitdat[3], splitdat[1], x.fName);
        }
      });
    }

  }


  // public uploadFile = (files) => {
  //   if (files.length === 0) {
  //     return;
  //   }

  //   let fileToUpload = <File>files[0];
  //   const formData = new FormData();
  //   formData.append('file', fileToUpload, fileToUpload.name);

  //   this.http.post('https://localhost:5001/api/upload', formData, {reportProgress: true, observe: 'events'})
  //     .subscribe(event => {
  //       if (event.type === HttpEventType.UploadProgress)
  //         this.progress = Math.round(100 * event.loaded / event.total);
  //       else if (event.type === HttpEventType.Response) {
  //         this.message = 'Upload success.';
  //         this.onUploadFinished.emit(event.body);
  //       }
  //     });
  // }

  documentURL() {
    this.dashboardService.getdocument_url().subscribe(data => this.success_docurl(data), err => this.failed_docurl(err));
  }

  success_docurl(data) {
    console.log(data);
    this.refreshdoc_list();
    this.documentrul = data;
    var urldoc = this.documentrul.filter(item => item.propertyName == "MainImagePathWebNetram")
    this.mainUrl = urldoc[0]?.propertyValue;
  }
  failed_docurl(err) {

  }

}
